// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L_hCV","textarea":"styles_textarea__2U8eP"};